import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html'
})
export class LoadingComponent implements OnInit {
  preloaderImageUrl: string;

  constructor(private startupConfigUiService: StartUpConfigUiService) {}

  ngOnInit(): void {
    this.startupConfigUiService
      .getPreloaderImageUrl()
      .pipe(take(1))
      .subscribe({
        next: (preloaderImageUrl) => {
          this.preloaderImageUrl = preloaderImageUrl;
        }
      });
  }
}
